import { storeKey } from './store';
import { Query } from 'apollo/types';

export default storeKey<Query['isLoggedIn']>('isLoggedIn', false, 'localStorage');
